import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import {ReactComponent as SearchIcon} from '../../assets/images/search.svg';
const SearchBox = ({searchQuery, onSearch, handleSearch}) => {
  const [localQuery, setLocalQuery] = useState(searchQuery);
  const isAlphanumeric = input => /^[a-zA-Z0-9\s]*$/.test(input);

  const handleSearchChange = event => {
    const {value} = event.target;

    if (isAlphanumeric(value) && !/^\s/.test(value)) {
      setLocalQuery(value);
    }

    if (value.trim() === '') {
      onSearch('');
    }
  };

  const handleSearchClick = () => {
    onSearch(localQuery);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onSearch(localQuery);
    }
  };

  return (
    <Box>
      <TextField
        className="text-regular-16px"
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#E4E4E4',
              borderWidth: '1px',
              borderRadius: '8px',
            },
            '&:hover fieldset': {
              borderColor: '#F37021',
              borderWidth: '1px',
              borderRadius: '8px',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#F37021',
              borderWidth: '1px',
              borderRadius: '8px',
            },
            '& input': {
              padding: '8px 16px',
            },
          },
        }}
        fullWidth
        variant="outlined"
        placeholder="Search Here"
        value={handleSearch ? searchQuery : localQuery}
        onChange={handleSearch ? handleSearch : handleSearchChange}
        onKeyDown={handleSearch ? null : handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon
                style={{cursor: 'pointer'}}
                onClick={handleSearchClick}
              />
            </InputAdornment>
          ),
        }}
        inputProps={{
          maxLength: 50,
        }}
      />
    </Box>
  );
};

SearchBox.propTypes = {
  searchQuery: PropTypes.any,
  handleSearch: PropTypes.any,
  onSearch: PropTypes.any,
  // filter: PropTypes.bool,
};

export default SearchBox;
